module.exports = __webpack_public_path__ + "img/map_12.8965f12d.webp";